// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
/** Joins class names and resolves conflicting Tailwind utilities (last wins). */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map